import React from 'react';
import { Box, Button, ButtonMode, ButtonSize, Dialog } from 'edenred-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';
import { useFormContext } from 'react-hook-form';
import {
  DialogCreateAnotherGroupProps,
  ICreateBenefitGroupForm
} from '@epi-models/pages/BenefitGroups';
import { useDispatch } from 'react-redux';

const DialogCreateAnotherGroup = ({
  openModal,
  toggleModal,
  defaultSettings
}: DialogCreateAnotherGroupProps) => {
  const { gray50, gray85, sizeMedium, sizeExtraExtraLarge, fontSemiBold } =
    useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { reset } = useFormContext<ICreateBenefitGroupForm>();

  const handleConfirmAddAnotherGroup = () => {
    reset(defaultSettings);
    toggleModal(false);
  };

  const handleRejectAddAnotherGroup = () => {
    toggleModal(false);
    dispatch(goToPage(routerPaths.benefitGroups));
  };

  return (
    <Dialog
      open={openModal}
      onClose={handleRejectAddAnotherGroup}
      disableBackdropClick
      maxWidth="md"
    >
      <Dialog.Title>
        <Box
          color={gray85}
          fontWeight={fontSemiBold}
          fontSize={sizeExtraExtraLarge}
        >
          {t('containers.benefit_groups.create_another.modal_title')}
        </Box>
      </Dialog.Title>
      <Dialog.Content>
        <Box color={gray50} fontSize={sizeMedium}>
          {t('containers.benefit_groups.create_another.modal_description')}
        </Box>
      </Dialog.Content>
      <Dialog.Actions>
        <Button
          id="confirm-create-another-group-button"
          mode={ButtonMode.Secondary}
          size={ButtonSize.Medium}
          type="button"
          onClick={handleRejectAddAnotherGroup}
          minWidth={120}
        >
          {t('containers.benefit_groups.create_another.modal_reject')}
        </Button>
        <Button
          id="reject-create-another-group-button"
          mode={ButtonMode.Secondary}
          size={ButtonSize.Medium}
          type="button"
          onClick={handleConfirmAddAnotherGroup}
          minWidth={120}
        >
          {t('containers.benefit_groups.create_another.modal_confirm')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export { DialogCreateAnotherGroup };
